import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten, timestampToDateForInput } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneClassroom from '../ones/OneClassroom';
import { MdAdd, MdCheck, MdClose, MdDelete, MdDeleteOutline, MdSms, MdWhatsapp } from "react-icons/md";

export default function View({ data, callback }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const itemTemplate = {
		name: '',
		quantity: 1,
		amount: 0,
		subTotal: 0,
	};

	

	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [dateDueString, setDateDueString] = useState("");
	const [studentUuids, setStudentUuids] = useState([""]);
	const [items, setItems] = useState([itemTemplate])
	const [totalAmount, setTotalAmount] = useState(0);


	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getAllStudents()
		])
		setReady(true);
	}

	
	function addItem() {
		setItems(_prev => {
			const _new = [..._prev];

			_new.push(itemTemplate);

			return _new;
		})
	}

	function handleItemChange(index, field, value) {
		setItems(_prev => {
			const _new = [..._prev];

			if(field === 'quantity' || field === 'amount') {
				_new[index][field] =  Number(value) || 0;
			} else {
				_new[index][field] = value;
			}

			//calculate subtotal
			_new[index].subTotal = (Number(_new[index].quantity) * Number(_new[index].amount) ) || 0;

			return _new;
		})
	}

	function deleteItem(index) {
		setItems(_prev => {
			const _new = [..._prev];

			_new.splice(index, 1)

			return _new;
		})
	}

	function addStudent() {
		setStudentUuids(_prev => {
			const _new = [..._prev];

			_new.push("");

			return _new;
		})
	}

	function handleStudentsChange(index, value) {
		setStudentUuids(_prev => {
			const _new = [..._prev];

			_new[index] = value;

			return _new;
		})
	}

	function deleteStudent(index) {
		setStudentUuids(_prev => {
			const _new = [..._prev];

			_new.splice(index, 1);

			return _new;
		})
	}

	function cleanStudents(_raw) {
		const _cleaned = [...new Set(_raw.filter((item, i) => {
			return (item && String(item).trim().length > 0 );
		}))];

		return _cleaned;
	}

	function getTotalAmount() {
		let _total = 0;

		if(items) {
			for (const item of items) {
				_total += Number(item.subTotal);
			}
		}

		setTotalAmount(_total);
	}

	function resetForm() {
		setTitle("");
		setDescription("");
		setDateDueString("");
		setStudentUuids([""])
		setItems([itemTemplate]);
	}

	async function create() {
		
    const _students = cleanStudents(studentUuids);

		if(title.trim().length > 0) {
			if(description.trim().length > 0) {
				if(dateDueString.trim().length > 0) {
					if(
						_students && _students.length >= 0 //support empty students, can be added later
					) {
						if(items && items.length > 0 && Number(totalAmount) > 0) {
							setLoading(true);
							await callApi(
								'create-individual-payment-cycle', 
								{
									title,
									description,
									dateDueString,
									studentUuids: JSON.stringify(studentUuids),
									items: JSON.stringify(items),
									totalAmount,
									schoolUuid: appContext.currentSchoolUuid,
								}
							).then((response) => {
								if(response.status === 1) {
									appContext.tellMessage("Payment Cycle was created successfully");
									resetForm();
									appContext.getAllIndividualPaymentCycles();
								} else {
									appContext.tellError(response.msg);
								}
							})
							setLoading(false);
						} else {
							appContext.tellError("Invalid items and amount to be paid");
						}
					} else {
						appContext.tellError("Invalid students");
					}
				} else {
					appContext.tellError("Invalid due date");
				}
			} else {
				appContext.tellError("Invalid description")
			}
		} else {
			appContext.tellError("Invalid title");
		}
	}

	async function edit() {
		

		if(title.trim().length > 0) {
			const _students = cleanStudents(studentUuids);

			if(description.trim().length > 0) {
				if(dateDueString.trim().length > 0) {
					if(
						_students && _students.length >= 0
					) {
						if(items && items.length > 0 && Number(totalAmount) > 0) {
							setLoading(true);
							await callApi(
								'edit-individual-payment-cycle', 
								{
									uuid: data.uuid,
									title,
									description,
									dateDueString,
									studentUuids: JSON.stringify(_students),
									items: JSON.stringify(items),
									totalAmount,
									schoolUuid: appContext.currentSchoolUuid,
								}
							).then((response) => {
								if(response.status === 1) {
									appContext.tellMessage("Payment Cycle was edited successfully");
									resetForm();
									appContext.getAllIndividualPaymentCycles();

									if(callback) {
										callback()
									}

								} else {
									appContext.tellError(response.msg);
								}
							})
							setLoading(false);
						} else {
							appContext.tellError("Invalid items and amount to be paid");
						}
					} else {
						appContext.tellError("Invalid students");
					}
				} else {
					appContext.tellError("Invalid due date");
				}
			} else {
				appContext.tellError("Invalid description")
			}
		} else {
			appContext.tellError("Invalid title");
		}
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		getTotalAmount()
	}, [ items ])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	useEffect(() => {
		if(data) {
			setTitle(data.title);
			setDescription(data.description);
			setStudentUuids(JSON.parse(data.studentUuids));
			setItems(JSON.parse(data.items));
			setTotalAmount(data.totalAmount);
			setDateDueString(timestampToDateForInput(data.dateDue));
		}
	}, [ data ])

	if (ready) {
		return (
		
			<div className="row">
				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Title</label>
					<input
						className="form-control"
						value={title}
						onChange={e => setTitle(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Description</label>
					<textarea
						className="form-control"
						value={description}
						onChange={e => setDescription(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Due Date</label>
					<input
						className="form-control"
						value={dateDueString}
						type="date"
						onChange={e => setDateDueString(e.target.value)}
					/>
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Applicable Students</label>
					<div
						style={{
							width: "100%",
							padding: "10px",
							border: "2px solid var(--mutedColor)"
						}}
					>
						<div
							style={{
								
							}}
						>
							<table
								className="table table-striped"
								style={{
									fontSize: "14px",
								}}
							>
								<thead>
									<tr
										style={{
											fontSize: "12px",
										}}
									>
										<th>Students</th>
										<th></th>
									</tr>
								</thead>

								<tbody>
									{
										studentUuids.map((item, i) => {
											return (
												<tr key={i}>
													<td>
														<select
															className="form-control"
															value={item}
															onChange={(e) => {
																handleStudentsChange(i, e.target.value)
															}}
														>
															<option value="">Select Student</option>
															{
																(appContext.allStudents && appContext.allStudents.length > 0) ?
																appContext.allStudents.map((item, i) => {
																	return (
																		<option value={item.uuid} key={i}>{item.firstName} {item.middleName} {item.lastName} - {item.classroomName} {(item.streamName) ? <>({item.streamName})</> :""}</option>
																	)
																})
																:""
															}
														</select>
													</td>

													<td
													>
														<MdDelete
															size={18}
															className="text-danger"
															style={{
																cursor: "pointer"
															}}
															onClick={() => {
																deleteStudent(i)
															}}
														/>
													</td>
												</tr>
											)
										})
									}

									
								</tbody>
							</table>

							
						</div>

						<button
							className="btn btn-outline-dark btn-sm mt-2"
							onClick={() => {
								addStudent()
							}}
						>
							<MdAdd
							 size={24}
							 
							/>
						</button>

					</div>
					
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Items</label>
					<div
						style={{
							width: "100%",
							padding: "10px",
							border: "2px solid var(--mutedColor)"
						}}
					>
						<div
							style={{
								
							}}
						>
							<table
								className="table table-striped"
								style={{
									fontSize: "14px",
								}}
							>
								<thead>
									<tr
										style={{
											fontSize: "12px",
										}}
									>
										<th>Name</th>
										<th>Quantity</th>
										<th>Amount in TZS</th>
										<th>Sub Total in TZS</th>
										<th></th>
									</tr>
								</thead>

								<tbody>
									{
										items.map((item, i) => {
											return (
												<tr key={i}>
													<td>
														<input
															className="form-control"
															value={item.name}
															onChange={(e) => {
																handleItemChange(i, 'name', e.target.value)
															}}
														/>
													</td>

													<td>
														<input
															className="form-control"
															value={item.quantity}
															onChange={(e) => {
																handleItemChange(i, 'quantity', e.target.value)
															}}
														/>
													</td>

													<td>
														<input
															className="form-control"
															value={item.amount}
															onChange={(e) => {
																handleItemChange(i, 'amount', e.target.value)
															}}
														/>
													</td>

													<td style={{ fontSize: "18px" }} className="font-semi-bold">
														{formatMoney(item.subTotal)}
													</td>

													<td
													>
														<MdDelete
															size={18}
															className="text-danger"
															style={{
																cursor: "pointer"
															}}
															onClick={() => {
																deleteItem(i)
															}}
														/>
													</td>
												</tr>
											)
										})
									}

									
								</tbody>
							</table>

							<div className="text-end mt-4">
								<h6
									style={{
										fontSize: "24px"
									}}
									className="font-semi-bold"
								>
									{formatMoney(totalAmount)} TZS
								</h6>
								<h6
									style={{
										fontSize: "18px"
									}}
									className="font-light"
								>
									GRAND TOTAL
								</h6>

								<hr/>
							</div>
						</div>

						<button
							className="btn btn-outline-dark btn-sm mt-2"
							onClick={() => {
								addItem()
							}}
						>
							<MdAdd
							 size={24}
							 
							/>
						</button>

					</div>
					
				</div>

				<div className="col-md-12 mt-2 mb-2 text-end">
					<button
						className="btn btn-secondary"
						onClick={() => {
							if(data) {
								appContext.activateDialog({
									message: `Changes you have made will be saved. Continue?`,
									onConfirm: edit,
								})
							} else {
								appContext.activateDialog({
									message: `Create new payment cycle?`,
									onConfirm: create,
								})
							}
						}}
					>
						<MdCheck/> Submit
					</button>
				</div>
			</div>
								
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}